import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader-component',
  templateUrl: './loader-component.component.html',
  styleUrls: ['./loader-component.component.scss'],
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule]
})
export class LoaderComponentComponent {
  private loaderService = inject(LoaderService);
  isLoading: Observable<boolean> = this.loaderService.isLoading;
}
